import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { apiClient } from 'modules/core/lib/mobx-rest'

import UnifiedAddEmployeeModal from 'modules/employees/components/UnifiedAddEmployeeModal'
import Loading from 'modules/layout/components/Page/Loading'

const AddEmployeePage = () => {
  const client = apiClient()
  const [submitting, setSubmitting] = React.useState(false)
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.employees.list.fullPath())
  }

  const source = { sourceType: 'employee_list' }

  const onSuccess = async (employeeId: number) => {
    setSubmitting(true)
    cleanMemberships() // In order to refresh teams section properly
    cleanEmployees() //To rferesh cache
    navigate(navigation.employees.id.fullPath({ id: employeeId }))
  }

  const cleanMemberships = () => {
    client.cache.evict('memberships')
  }

  const cleanEmployees = () => {
    client.cache.evict('employees')
    client.cache.evict('users')
  }

  if (submitting) {
    return <Loading />
  }

  return <UnifiedAddEmployeeModal onClose={onClose} source={source} onSuccess={onSuccess} />
}

export default AddEmployeePage
